import { StorageService } from '@nextgen-web-framework/core';
import { WebEvents, WebEventsEnum } from '@commerce-webcomponents/sdk';
import { FulfillmentApi } from '@commerce-fulfillment-webcomponents/sdk';
import { LocalStorageKeys } from '..';
import { checkoutFulfillmentOptions } from '../../types';
import { isEasyDeliveryOrBopisOption } from '../../transformers';
import {
  CheckoutServiceLocation,
  CheckoutProfileFulfillment,
  CheckoutServiceLevel,
  CheckoutProfile,
  Address,
} from './../models/';
import { CheckoutProfileInterface } from './types/propsType';

const CheckoutProfileService = ((): CheckoutProfileInterface => {
  const updateDeliveryOption = (checkoutDeliveryOption: CheckoutServiceLevel) => {
    const localStorage = StorageService.getLocalStorage();
    let checkoutProfile = getCheckoutProfile();
    checkoutProfile = {
      ...checkoutProfile,
      fulfillmentType: {
        ...checkoutProfile?.fulfillmentType,
        serviceLevel: { ...checkoutProfile?.fulfillmentType?.serviceLevel, ...checkoutDeliveryOption },
      },
    };
    localStorage.store(LocalStorageKeys.CHECKOUT_PROFILE, checkoutProfile);
  };
  const updateFulfillmentType = (checkoutProfileFullfillment: CheckoutProfileFulfillment) => {
    const localStorage = StorageService.getLocalStorage();
    let checkoutProfile = getCheckoutProfile();
    checkoutProfile = {
      ...checkoutProfile,
      fulfillmentType: { ...checkoutProfile?.fulfillmentType, ...checkoutProfileFullfillment },
    };
    localStorage.store(LocalStorageKeys.CHECKOUT_PROFILE, checkoutProfile);
  };
  const updateServiceLocation = (checkoutServiceLocation: CheckoutServiceLocation) => {
    const localStorage = StorageService.getLocalStorage();
    let checkoutProfile = getCheckoutProfile();
    checkoutProfile = {
      ...checkoutProfile,
      fulfillmentType: {
        ...checkoutProfile?.fulfillmentType,
        serviceLocation: {
          ...checkoutServiceLocation,
          ...(!isEasyDeliveryOrBopisOption(checkoutProfile?.fulfillmentType?.id) && {
            name: checkoutServiceLocation?.address?.line1,
          }),
        },
      },
    };
    localStorage.store(LocalStorageKeys.CHECKOUT_PROFILE, checkoutProfile);
  };

  const updateDeliveryAddress = (deliveryAddress?: Address, updateDeliveryAddressOnly?: boolean) => {
    const localStorage = StorageService.getLocalStorage();
    let checkoutProfile = getCheckoutProfile();
    checkoutProfile = {
      ...checkoutProfile,
      fulfillmentType: {
        ...checkoutProfile?.fulfillmentType,
        serviceLevel: { ...checkoutProfile?.fulfillmentType?.serviceLevel, deliveryAddress },
        ...(!updateDeliveryAddressOnly && { id: checkoutFulfillmentOptions.HOMEDELIVERY }),
      },
    };
    localStorage.store(LocalStorageKeys.CHECKOUT_PROFILE, checkoutProfile);
  };

  const updateShippingType = (shippingType: string) => {
    const localStorage = StorageService.getLocalStorage();
    let checkoutProfile = getCheckoutProfile();
    checkoutProfile = {
      ...checkoutProfile,
      fulfillmentType: {
        ...checkoutProfile?.fulfillmentType,
        id: shippingType,
      },
    };
    localStorage.store(LocalStorageKeys.CHECKOUT_PROFILE, checkoutProfile);
  };

  const getCheckoutProfile = () => {
    const localStorage = StorageService.getLocalStorage();
    return localStorage.retrieve(LocalStorageKeys.CHECKOUT_PROFILE) as unknown as CheckoutProfile;
  };
  const updatePayment = (paymentMethodId?: string) => {
    if (paymentMethodId) {
      const localStorage = StorageService.getLocalStorage();
      let checkoutProfile = getCheckoutProfile();
      checkoutProfile = {
        ...checkoutProfile,
        payment: {
          ...checkoutProfile?.payment,
          paymentMethodId: paymentMethodId,
        },
      };
      localStorage.store(LocalStorageKeys.CHECKOUT_PROFILE, checkoutProfile);
    }
  };

  const updateSelectedServiceLocation = async () => {
    const checkoutProfile = getCheckoutProfile();
    const serviceLocationId = checkoutProfile?.fulfillmentType?.serviceLocation?.id;
    if (serviceLocationId) {
      const baseUrl = ApiConfigService.getBaseUrl();
      const res = await FulfillmentApi.getServiceLocationById({
        serviceLocationId,
        baseUrl,
      });
      if (res) {
        updateServiceLocation(res as CheckoutServiceLocation);
        WebEvents.publishEvent({
          event: WebEventsEnum.UpdateCheckoutProfileAddress,
          payload: {},
          sync: false,
        });
      }
    }
  };

  return {
    updateDeliveryOption,
    updateFulfillmentType,
    updateServiceLocation,
    getCheckoutProfile,
    updatePayment,
    updateDeliveryAddress,
    updateShippingType,
    updateSelectedServiceLocation,
  };
})();

export { CheckoutProfileService };
export type { CheckoutProfileInterface };
